import { QRCodeSVG } from 'qrcode.react'

const URL = 'https://ctrl.kcolb.com'

export default function HiringHarder() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-8">
      <h1 className="font-heading font-black text-5xl text-primary tracking-tactical">HIREHARD</h1>
      <div className="p-4 bg-white">
        <QRCodeSVG value={URL} size={256} />
      </div>
      <p className="text-xs text-text-muted tracking-tactical">{URL}</p>
    </div>
  )
}
